import { wrap, Wrapper, Molecule } from 'AppReact';
import RadioButton from 'atoms/radioButton';
import Text from 'atoms/text';
import styled, { css } from 'styled-components';


const template = styled.div`
  ${({ displayState, theme }) => css`
    pointer-events: ${displayState?.disabledBtn && 'none'};
    display: flex; align-items: center; cursor: pointer`
    }
`;



export default Molecule({
    template,
    type: 'button',
    atoms: [
        {
            component: RadioButton,
            name: 'Radio',
            displayState: ({ selected }) => {
                return { selected }
            }
        },
        {
            component: wrap(Text, Wrapper(styled.div`margin-left: 10px`)),
            name: 'Label',
            displayValue: ({ label }) => label
        }
    ]
})